module.exports = __webpack_public_path__ + "img/体测报告btn.74b1fa01.jpg";